import { MyAccountStoreClientConfig } from "../types";

/**
 * Test Lab is the first MyAccountStore instance. This client config drives
 * the React shell — copy keys, filter dimensions, sections — and pairs with
 * the server config in `funnel-common/src/managers/MyAccountStoresManager.ts`.
 *
 * Translation keys all live under `my_account/Stores/TestLab/...` (see
 * `client/resources/translations/{de,en,fr}/my_account/translations.json`).
 */
export const testLabStoreConfig: MyAccountStoreClientConfig = {
  storeKey: "test_lab",
  allowedCountries: ["de", "ch"],
  translationNamespace: "my_account",
  translationPrefix: "Stores/TestLab",
  menuLinkId: "test-lab",

  // Show 10 tests, then the "Vollständige Liste" button reveals the rest.
  collapsedProductCount: 10,

  filterDimensions: [
    {
      dimensionKey: "biomarkers",
      labelTranslationKey: "Stores/TestLab/filters/biomarkers/label",
      // Master list mirrors `cms/src/Builders/testLabMasterData.ts`. The
      // labels themselves come from translations under
      // Stores/TestLab/filters/biomarkers/values/<value>.
      values: [],
    },
    {
      dimensionKey: "symptoms",
      labelTranslationKey: "Stores/TestLab/filters/symptoms/label",
      values: [],
    },
  ],

  card: {
    tagDimensions: ["biomarkers", "symptoms"],
  },

  howItWorks: {
    titleTranslationKey: "Stores/TestLab/howItWorks/title",
    steps: [
      {
        iconSrc: "/images/my_account/test_lab/how_it_works_1.png",
        titleTranslationKey: "Stores/TestLab/howItWorks/steps/0/title",
        descriptionTranslationKey: "Stores/TestLab/howItWorks/steps/0/description",
      },
      {
        iconSrc: "/images/my_account/test_lab/how_it_works_2.png",
        titleTranslationKey: "Stores/TestLab/howItWorks/steps/1/title",
        descriptionTranslationKey: "Stores/TestLab/howItWorks/steps/1/description",
      },
      {
        iconSrc: "/images/my_account/test_lab/how_it_works_3.png",
        titleTranslationKey: "Stores/TestLab/howItWorks/steps/2/title",
        descriptionTranslationKey: "Stores/TestLab/howItWorks/steps/2/description",
      },
    ],
  },

  faq: {
    titleTranslationKey: "Stores/TestLab/faq/title",
    items: [
      { questionTranslationKey: "Stores/TestLab/faq/items/0/question", answerTranslationKey: "Stores/TestLab/faq/items/0/answer" },
      { questionTranslationKey: "Stores/TestLab/faq/items/1/question", answerTranslationKey: "Stores/TestLab/faq/items/1/answer" },
      { questionTranslationKey: "Stores/TestLab/faq/items/2/question", answerTranslationKey: "Stores/TestLab/faq/items/2/answer" },
      { questionTranslationKey: "Stores/TestLab/faq/items/3/question", answerTranslationKey: "Stores/TestLab/faq/items/3/answer" },
      { questionTranslationKey: "Stores/TestLab/faq/items/4/question", answerTranslationKey: "Stores/TestLab/faq/items/4/answer" },
    ],
  },

  walkMe: {
    seenStorageKey: "my_account_store_walkme_seen:test_lab",
    titleTranslationKey: "Stores/TestLab/walkMe/title",
    bodyTranslationKey: "Stores/TestLab/walkMe/body",
    ctaTranslationKey: "Stores/TestLab/walkMe/cta",
    dismissTranslationKey: "Stores/TestLab/walkMe/dismiss",
    targetMenuLinkId: "test-lab",
  },
};
